import { resolveCountry } from "./FormatByCountry";

const numberOnly = (value: string) => {
  const country = resolveCountry();
  if (country === "MY") {
    // MY: `,` ribuan, `.` desimal — biarkan dot tetap
    return value
      .replace(/[^0-9,.]+/, "")
      .replace(/,+/g, ",")
      .replace(/,(\d+),/g, ",$1");
  }
  // ID: `.` ribuan, `,` desimal — convert dot → comma
  return value
    .replace(/[^0-9,.]+/, "")
    .replace(/\.+/g, ",")
    .replace(/,(.+),/g, ",$1");
};
export default numberOnly;
